import "./navbar.styles.scss"
import Icon from "../components/icon/icon.component"
import { Link } from "react-router-dom"

function Navbar(props) {
  return (
    <div className="nav-bar-wrapper">
      <a href="./">
        <div className="logo" style={{ padding: "1rem" }}>
          <Icon name="logo" />
        </div>
      </a>
      {props.homepage_disabled ? (
        ""
      ) : (
        // <div className="main-links">
        //   <Link
        //     onClick={() => {
        //       document
        //         .getElementById("founder")
        //         .scrollIntoView({ behavior: "smooth" })
        //     }}
        //   >
        //     <div>Founder's story</div>
        //   </Link>
        //   <Link
        //     onClick={() => {
        //       document
        //         .getElementById("problem")
        //         .scrollIntoView({ behavior: "smooth" })
        //     }}
        //   >
        //     <div>Problem</div>
        //   </Link>
        //   <Link
        //     onClick={() => {
        //       document
        //         .getElementById("demo")
        //         .scrollIntoView({ behavior: "smooth" })
        //     }}
        //   >
        //     <div>Why us?</div>
        //   </Link>
        // </div>
        <></>
      )}
      <div className="buttons">
        <Link
          className="main-links"
          onClick={() => {
            document
              .getElementById("learner")
              .scrollIntoView({ behavior: "smooth" })
          }}
        >
          <div>Learners</div>
        </Link>

        <Link
          className="main-links"
          onClick={() => {
            document
              .getElementById("tutor")
              .scrollIntoView({ behavior: "smooth" })
          }}
        >
          <div>Tutors</div>
        </Link>
        <Link
          className="main-links"
          onClick={() => {
            document
              .getElementById("creator")
              .scrollIntoView({ behavior: "smooth" })
          }}
        >
          <div>Creators</div>
        </Link>

        <a href="/Litepaper.pdf">
          <div>Litepaper</div>
        </a>
      </div>
    </div>
  )
}

export default Navbar
